module.exports = __webpack_public_path__ + "static/media/avatar.a33f2d3c.svg";